export type SortDir = 'asc' | 'desc';

export function toggleSort(currentKey: string, currentDir: SortDir, nextKey: string): { key: string; dir: SortDir } {
  if (currentKey === nextKey) {
    return { key: nextKey, dir: currentDir === 'asc' ? 'desc' : 'asc' };
  }
  return { key: nextKey, dir: nextKey === 'timestamp' || nextKey === 'clock_in' || nextKey === 'started' || nextKey.includes('seen') ? 'desc' : 'asc' };
}

export function compareSortValues(a: unknown, b: unknown): number {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  const as = String(a).toLowerCase();
  const bs = String(b).toLowerCase();
  if (as < bs) return -1;
  if (as > bs) return 1;
  return 0;
}

export function sortRows<T>(rows: T[], key: string, dir: SortDir, getValue: (row: T, key: string) => unknown): T[] {
  const sign = dir === 'asc' ? 1 : -1;
  return [...rows].sort((left, right) => compareSortValues(getValue(left, key), getValue(right, key)) * sign);
}
